import router from './router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'

NProgress.configure({ showSpinner: false })

/** 白名单列表 */
const whiteList = ['/login', '/auth-redirect', '/bind', '/register','/','/marketSituation','/presaleList','/infoList','/biddingHall','/policyList','/technologyClass','/search']

router.beforeEach((to, from, next) => {+
  next()
  window.scrollTo(0,0)
  return false
  NProgress.start()
  console.log('getToken()',getToken())
  if (getToken()) {
    /* has token*/
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      next()
    }
  }
  else {
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next()
    } else {
      if (to.fullPath == '/index') {
        next(`/login`) // 否则全部重定向到登录页
      }
      else {
        next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
      }
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})

